export { BannerTalentBank } from './BannerTalentBank'
export { ListVacancies } from './ListVacancies'
export { BoxSearch } from './BoxSearch'
export { Testimonials } from './Testimonials'
export { Company } from './Company'
